const actionTypes = {
    GET_REF_DATA_ENRICH_SETUPS: 'GET_REF_DATA_ENRICH_SETUPS',
    GET_REF_DATA_ENRICH_CONFIGS: 'GET_REF_DATA_ENRICH_CONFIGS',
};

export default actionTypes;